// Interface of the soundService because we won't expose the soundServiceController because it has to have a non-public constructor. 
export interface ISoundService {
    getSoundPath(fileName: string): string;
}

class SoundServiceController {
    constructor(private assetsBaseUrl: string, prefix: string) {
        if (!assetsBaseUrl) {
            throw new Error('Could not create new soundService without assetsBaseUrl');
        }
        controllers[prefix] = this;
    }

    public getSoundPath(fileName: string): string {
        return this.assetsBaseUrl + 'sounds/' + fileName;
    }    
}

const controllers = {}

// SoundService is setUp as a Singleton per type. 
// This gives the possibility to create a SoundService for the chatbot and a soundService for the account part. 
// For each type, the SoundService has to be initiated once with a baseUrl and a configurationPrefix (for example 'chatbot' or 'account').
// After the initialization every component can just get the service by calling SoundService({type});
export const SoundService = (configurationPrefix: string, baseUrl = null): ISoundService => {
    return !!controllers[configurationPrefix] ?
        controllers[configurationPrefix] :
        new SoundServiceController(baseUrl, configurationPrefix);
}
    